// Final Merged ArchivedSessions.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/ArchivedSessions.css";
import { IoIosArrowBack } from "react-icons/io";
import logo from "../../../assets/icons/NewLogo.png";
import DeleteIcon from "../../../assets/icons/delete.svg";
import { PatientServices } from "../services/PatientServices";

function ArchivedSessions() {
  const [selectMode, setSelectMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [actionType, setActionType] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [archiveConversation, setArchiveConversation] = useState([]);
  const [conversation_id, setConversation_id] = useState("");
  const [actionSource, SetActionSource] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const ArchiveConversations = async () => {
      try {
        const response = await PatientServices.fetchArchiveConversations();
        const data = response?.conversations || [];
        setArchiveConversation(data);
      } catch (error) {
        console.error("Error loading Archieve conversations:", error);
      }
    };

    ArchiveConversations();
  }, []);

  const toggleSelectMode = () => {
    setSelectMode(!selectMode);
    setSelectedItems([]);
  };

  const handleCheckbox = (index) => {
    console.log("conversation ids", index);
    if (selectedItems.includes(index)) {
      setSelectedItems(selectedItems.filter((i) => i !== index));
    } else {
      setSelectedItems([...selectedItems, index]);
    }
  };

  const handleRestore = (conversation_id, index, source) => {
    if (source === "one") {
      SetActionSource(false);
    } else if (source === "many") {
      SetActionSource(true);
    }
    setActionType("restore");
    setShowConfirmPopup(true);
    setConversation_id(conversation_id);
  };

  const handleDelete = (conversation_id, source) => {
    if (source === "one") {
      SetActionSource(false);
    } else if (source === "many") {
      SetActionSource(true);
    }
    setActionType("delete");
    setConversation_id(conversation_id);
    setShowConfirmPopup(true);
  };

  const deleteArchive = async (conv_id) => {
    try {
      console.log(
        "conversation id for deleting the archieve conversation",
        conv_id
      );
      const response = await PatientServices.deleteArchive(conv_id);
      console.log("conversation deleted successfully", response);
    } catch (error) {
      console.error("error while deleting the conversation", error);
    }
  };

  const deleteMany = async (selectedItems) => {
    try {
      console.log("conversavation_ids passsing to the apis", selectedItems);
      const response = await PatientServices.deleteMany(selectedItems);
      console.log("conversation ids deleted succesfully", response);
    } catch (error) {
      console.error("error while deleting mutiple conversations", error);
    }
  };

  const restoreMany = async (selectedItems) => {
    try {
      console.log(
        "conversations_ids passed to restore many conversations",
        selectedItems
      );
      const response = await PatientServices.restoreMany(selectedItems);
      console.log("successfully deleted the comversations", response);
    } catch (error) {
      console.error("error while restoring multiple conversations", error);
    }
  };

  return (
    <div className="archived-container">
      <div className="archived-header">
        <button className="archived-back-button" onClick={() => navigate(-1)}>
          <IoIosArrowBack size={18} />
          <span></span>
        </button>
        <img src={logo} alt="Logo" className="archived-logo" />
      </div>

      <div className="archived-content">
        <div className="archived-title-bar">
          <h2>Archived Sessions ({archiveConversation.length})</h2>
          <span
            className="archived-select-link"
            onClick={() => {
              if (!selectMode) {
                setSelectMode(true);
              } else if (selectedItems.length !== archiveConversation.length) {
                setSelectedItems(archiveConversation.map((_, i) => i));
              } else {
                setSelectMode(false);
                setSelectedItems([]);
              }
            }}
          >
            {!selectMode
              ? "Select"
              : selectedItems.length !== archiveConversation.length
              ? "Select all"
              : "Cancel"}
          </span>
        </div>

        <div className="archived-list">
          {archiveConversation.map((session, index) => (
            <div key={session.conversation_id} className="archived-session-row">
              <div className="archived-session-label">
                {selectMode && (
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(session.conversation_id)}
                    onChange={() => handleCheckbox(session.conversation_id)}
                  />
                )}
                <span>{session.title}</span>
              </div>

              <button
                className="archived-more-btn"
                onClick={() =>
                  setActiveMenuIndex(activeMenuIndex === index ? null : index)
                }
              >
                ⋮
              </button>

              {activeMenuIndex === index && (
                <div className="archived-popup-menu">
                  <div
                    className="archived-popup-option"
                    onClick={() =>
                      handleRestore(session.conversation_id, null, "one")
                    }
                  >
                    <span style={{ fontSize: "20px", marginRight: "8px" }}>
                      ⟲
                    </span>{" "}
                    Restore
                  </div>
                  <hr />
                  <div
                    className="archived-popup-option delete"
                    onClick={() =>
                      handleDelete(session.conversation_id, index, "one")
                    }
                  >
                    <img
                      src={DeleteIcon}
                      alt="Delete"
                      className="setting-icon"
                      style={{ marginRight: "8px" }}
                    />{" "}
                    Delete
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {selectMode && (
          <div className="archived-footer">
            <button className="restore-btn" onClick={handleRestore}>
              ⟲ Restore
            </button>
            <button
              className="delete-btn"
              onClick={() => handleDelete(null, null, "many")}
            >
              <img
                src={DeleteIcon}
                alt="Delete"
                className="setting-icon"
                style={{
                  width: "18px",
                  height: "18px",
                  marginRight: "8px",
                  filter: "brightness(0) invert(1)",
                  verticalAlign: "middle",
                }}
              />{" "}
              Delete
            </button>
          </div>
        )}
      </div>

      {showConfirmPopup && (
        <div className="overlay-modal">
          <div className="confirm-modal">
            <h3>
              Permanently {actionType === "delete" ? "Delete" : "Restore"}?
            </h3>
            <p>
              Do you want to {actionType === "delete" ? "delete" : "restore"}{" "}
              permanently?
            </p>

            <div className="confirm-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowConfirmPopup(false)}
              >
                No
              </button>
              <button
                className="confirm-btn"
                onClick={() => {
                  setShowConfirmPopup(false);                
                  if (actionSource && actionType === "delete") {
                    deleteMany(selectedItems);
                  } else if (actionSource && actionType === "restore") {
                    restoreMany(selectedItems);
                  } else if (!actionSource && actionType === "delete") {
                    deleteArchive(conversation_id);
                  } else if (!actionSource && actionType === "restore") {
                    // restoreArchive(conversation_id);
                  }
                  setSuccessMessage(
                    actionType === "delete"
                      ? "Successfully Deleted!"
                      : "Successfully Restored!"
                  );
                  setShowSuccessPopup(true);
                  setTimeout(() => setShowSuccessPopup(false), 2000);
                }}
              >
                {actionType === "delete" ? "Delete" : "Restore"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="success-toast">
          <span>{successMessage}</span>
        </div>
      )}
    </div>
  );
}

export default ArchivedSessions;
